import { createEntityService } from "./base/entityServiceBase";
import { getMattersBalances } from "./postingsService";

const baseService = createEntityService({
  name: "matterBalances",
  apiFetchFn: getMattersBalances,
});

const matterBalancesReducer = baseService.reducer;
const useMatterBalances = baseService.useEntityData;
const getMatterBalancesData = baseService.getData;

export { matterBalancesReducer, useMatterBalances, getMatterBalancesData };
